/**
 * ADRESSEN TIL SALER (QA15-S B3): hvilken fane, og fanens egne filtre.
 *
 * Salen står i stien (`/venue/:id/rooms/:roomId`; uten den er det «Alle saler»). Fanen heter
 * `section` fordi `tab` og `view` alt er tatt av listene som bor under den (forespørslenes faner og
 * arrangementenes liste/kalender). De gamle adressene `/events` og `/requests` sender hit med sine
 * filtre, så bokmerker og varsler lander.
 */
import { validateVenueRequestsSearch } from '@/features/date-requests/venue-requests-search';
import type { VenueRequestsSearch } from '@/features/date-requests/venue-requests-search';

import { validateEventsSearch, type EventsSearch } from './events-search';

export const ROOM_SECTIONS = ['events', 'requests', 'spec'] as const;
export type RoomSection = (typeof ROOM_SECTIONS)[number];

export type RoomsSearch = Omit<EventsSearch, 'roomId'> &
  VenueRequestsSearch & {
    section?: RoomSection;
  };

export function validateRoomsSearch(search: Record<string, unknown>): RoomsSearch {
  /* Salen står i stien; en `roomId` i søket ville vært et salvalg nummer to. */
  const { roomId: _room, ...events } = validateEventsSearch(search);
  const section = search['section'];
  return {
    ...events,
    ...validateVenueRequestsSearch(search),
    ...(typeof section === 'string' && (ROOM_SECTIONS as readonly string[]).includes(section)
      ? { section: section as RoomSection }
      : {}),
  };
}
